import Vue from 'vue';
import { createPinia, defineStore } from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import Axios from 'axios';
Axios.defaults.withCredentials = true;

const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);
Vue.use(pinia);

export const useUserStore = defineStore("user", {
  state: () => {
    return {
      token: '',
      user: null,
      loginMethod: -1,
    }
  }, actions: {
    setToken(value) {
      this.token = value;
    },
    setUser(value) {
      this.user = value;
    },
    setLoginMethod(value) {
      this.loginMethod = value;
    },
    reset() {
      this.token = '';
      this.user = null;
      this.loginMethod = -1;
    },
    login(token, user) {
      this.token = token;
      this.user = user;
    }
  }, getters: {
    isLoggedIn(state) {
      return state.user !== null;
    },
    getUser(state) {
      return state.user;
    },
    getLoginMethod(state) {
      return state.loginMethod;
    }
  },
  persist: {
    enabled: true,
    storage: sessionStorage,
  }
});
